export default __webpack_public_path__ + "static/media/carfix_newlogo.9cba7b97.svg";